/**
 * Created by rak on 8/24/2018.
 */
'use strict';
angular.module('tachoHistoryDashboard', ['ui.router']).config(function ($stateProvider) {
  $stateProvider
    .state('tachohistorydashboard', {
      parent: 'driverdashboard',
      url: '/tachohistorydashboard',
      ncyBreadcrumb: {
        label: 'Track'
      },
      views: {
        'content@app': {
          templateUrl: 'components/dashboard/tachoHistoryDashboard/tachoHistoryDashboard.tpl.html',
          controller: 'TachoHistoryCtrl'
        }
      },
      resolve: {
        $title: function () {
          return 'BetoTrack', 'Fleet Management Dashboard';
        },
        $sibebar: ['AdmStatusService', function (AdmStatusService) {
          AdmStatusService.setSidebarVisible(true);
          return true;
        }]
      }
    });
});



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/tachoHistoryDashboard/tachoHistoryDashboard.js